import { NutritionalInfo } from "@/clients/models/NutritionalInfo";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface CarbLabelProps {
  hasCarbOption: boolean;
  carbOption?: string | null;
  portionSize?: string | null;
  productComplexity?: string | null;
  ingredientQuantities?: Array<string> | null;
  ingredients?: Array<string> | null;
  nutritionalInfo?: NutritionalInfo | null;
}

export const CarbLabel = memo(function CarbLabel({
  hasCarbOption,
  carbOption,
  portionSize,
  productComplexity,
  ingredientQuantities,
  ingredients,
  nutritionalInfo,
}: CarbLabelProps) {
  const isComposite = productComplexity?.toLowerCase() === "composite";
  const portionText = portionSize ?? "--";
  const ingredientSummary = (ingredientQuantities ?? ingredients ?? []).filter(Boolean).join(", ");

  const portion = nutritionalInfo?.perPortion;
  const calories = portion?.energy?.kcal;
  const protein = portion?.protein?.grams;
  const carbs = portion?.carbohydrate?.total?.grams;
  const fat = portion?.fat?.total?.grams;
  const hasMacros = calories != null || protein != null || carbs != null || fat != null;

  return (
    <div className="flex min-w-0 items-center gap-2">
      {hasMacros && (
        <p className={cn(textVariants.footnote, "flex min-w-0 truncate text-[#515151] gap-x-[12px]")}>
          {calories != null && <span>{calories} kcal</span>}
          {protein != null && <span><span className="font-bold">P: </span>{protein}g</span>}
          {carbs != null && <span><span className="font-bold">C: </span>{carbs}g</span>}
          {fat != null && <span><span className="font-bold">F: </span>{fat}g</span>}
        </p>
      )}
      {isComposite && hasCarbOption && (
        <span
          className={cn(
            textVariants.footnote,
            "h-fit w-fit shrink-0 rounded-full px-1.5 py-0.5 text-center",
            "bg-carb-option font-medium text-black",
          )}
        >
          + Carb Swap
        </span>
      )}
      {!hasCarbOption && carbOption ? (
        <p className={cn(textVariants.footnote, "shrink-0 text-[#515151]")}>{carbOption}</p>
      ) : null}
    </div>
  );
});
